// Define regex patterns at the top level for better performance
const APPLE_DEVICE_PATTERN = /Mac|iPhone|iPad|iPod/i;
const ANDROID_PATTERN = /Android/;

/**
 * Creates a map link that opens in the appropriate map application
 * @param {number|string} latOrAddress - Latitude or full address string
 * @param {number} [lng] - Longitude (optional if using address)
 * @param {object} [address] - Optional address object with address components
 * @returns {string} URL that will open in appropriate map application
 */
function mapHref(latOrAddress, lng, address) {
  // If we have an address object, construct the full address string
  const searchQuery = address
    ? [
        address.address,
        address.address2,
        `${address.city}, ${address.region} ${address.postalCode}`,
        address.country,
      ]
        .filter(Boolean)
        .join(', ')
    : latOrAddress;

  // Handle non-browser environments
  if (typeof navigator === 'undefined') {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(searchQuery)}`;
  }

  // If we have coordinates, format them as a string
  const query = lng ? `${latOrAddress},${lng}` : searchQuery;
  const encodedQuery = encodeURIComponent(query);

  // Check for any Apple device (macOS, iOS, iPadOS)
  if (
    // Modern browsers
    navigator.userAgentData?.platform === 'macOS' ||
    // Legacy browsers
    APPLE_DEVICE_PATTERN.test(navigator.userAgent)
  ) {
    return `maps://maps.apple.com/?q=${encodedQuery}`;
  }

  // Check for Android devices
  if (ANDROID_PATTERN.test(navigator.userAgent)) {
    // Use address search if no coordinates provided
    if (!lng) {
      return `geo:0,0?q=${encodedQuery}`;
    }
    return `geo:${latOrAddress},${lng}?q=${encodedQuery}`;
  }

  // Default to Google Maps web URL for desktop browsers
  return `https://www.google.com/maps/search/?api=1&query=${encodedQuery}`;
}

export default mapHref;
